export default {
    getInstituteExamSetting: '/examSettings/getInstituteExamSetting'
  }
